// =============================================================================
// openAfterAsync — open a document URL that must first be resolved (signed
// URL, edge-function call) without losing the popup permission.
//
// iOS Safari — browser tab AND installed PWA — only honours window.open
// inside the synchronous user-gesture stack. `await createSignedUrl(...)`
// followed by `window.open(url)` is silently blocked on iPhone: the button
// appears to do nothing (mobile audit 2026-07-19, S1 — five sites).
//
// Call this directly from the click handler. It claims a blank window
// synchronously (while the gesture token is live), resolves the URL, then
// points the window at it. On failure the placeholder closes and the error
// rethrows so the caller can show its own dialog.
// =============================================================================

export async function openAfterAsync(getUrl: () => Promise<string>): Promise<void> {
  const win = window.open('', '_blank')
  try {
    const url = await getUrl()
    if (win) win.location.href = url
    // Popup denied anyway (rare outside the await case) — last-ditch direct
    // open; desktop browsers generally allow it.
    else window.open(url, '_blank')
  } catch (e) {
    win?.close()
    throw e
  }
}
